import { MdDeleteForever } from "react-icons/md";

interface Props {
  text: string;
  value: number;
  handleRemoveLine: () => void;
}

const ExpenseLine = ({ text, value, handleRemoveLine }: Props) => {
  return (
    <div className="flex">
      <ul className="flex py-4 px-8 flex-row w-full justify-between font-inter">
        <li>{text}</li>
        <div className="flex flex-row items-center gap-8">
          <li className="font-bold">{value}€</li>
          <li className="pl-8 border-l border-almost-white">
            <MdDeleteForever
              onClick={() => handleRemoveLine()}
              className="fill-light-gray hover:fill-red-error cursor-pointer"
            />
          </li>
        </div>
      </ul>
    </div>
  );
};

export default ExpenseLine;
